var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.50008 10.9142L11.7072 4.70711L10.293 3.29289L5.50008 8.08578L3.70718 6.29289L2.29297 7.70711L5.50008 10.9142Z","fill":"white"}));
}

Checkmark.defaultProps = {"width":"18","height":"18","viewBox":"0 0 14 14","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
